import { render, staticRenderFns } from "./new_news.vue?vue&type=template&id=4d854024&scoped=true"
import script from "./new_news.vue?vue&type=script&lang=js"
export * from "./new_news.vue?vue&type=script&lang=js"
import style0 from "./new_news.vue?vue&type=style&index=0&id=4d854024&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d854024",
  null
  
)

export default component.exports